import { styled } from '@slal/ui';
import { P } from '@slal/ui/typography';
import { CardButton, LoadingSpinner } from '~/components';

export const StyledSpinner = styled(LoadingSpinner)`
    display: block;
    width: 50px;
    color: #147cb3;
    margin: 0 auto;
`;

export const GenerateReportButton = styled(CardButton)`
    &:disabled {
        background: #b8d7e8;
        border: #b8d7e8 !important;
        opacity: 1;
    }
    min-width: 160px;
    .pdfIcon {
        margin-left: 8px;
    }
`;

export const StyledStatusMessage = styled(P)`
    margin: ${({ theme }) => theme.space[4]} 0;
    color: ${({ theme }) => theme.colors.neutral__light__70};
`;

export const AlertWrapper = styled.div`
    margin-top: ${({ theme }) => theme.space[6]};
`;
